import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import type { MasyuPresence } from "./Player";
import { registerMasyuTranslations } from "./i18n";
import { localFeedback } from "./localCheck";
import { emptyDefinition, emptyProgress, migrateProgress, serializeSubmission } from "./progress";
import { emptySolution } from "./solution";
import type { MasyuDefinition, MasyuProgress, MasyuSolution, MasyuSubmission } from "./types";

registerMasyuTranslations(i18n);

export const masyuModule: PuzzleTypeModule<
  MasyuDefinition,
  MasyuSubmission,
  MasyuProgress,
  MasyuSolution,
  MasyuPresence
> = {
  key: "masyu",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  localFeedback,
};
